import React, { useEffect, useState } from 'react';
import { inWords } from '../../components/global';
import formatAmount from 'indian-currency-formatter';
import './PlusMinusInput.css'

function PlusMinusInputHealth(props) {
    const amount = props.amount;
    //const setAmount = props.setAmount;


    const[formated_amount, set_formated_amount] = useState(formatAmount(amount)); 
    // eslint-disable-next-line 
    const ChangeAnnualIncomeHandle = (e) =>{  
        const plan_amount = (e.target.value).replace(/,/g, '') ;
        props.setAmount(parseInt(plan_amount));
        set_formated_amount( formatAmount( plan_amount ) ); 
    }

    const plusAmount = () => {

        const currentAmount = props.amount;
        if (currentAmount === 500000) {
            props.setAmount(700000);
            set_formated_amount(formatAmount(700000));
        }else if(currentAmount === 700000){
            props.setAmount(1000000);
            set_formated_amount(formatAmount(1000000));
        }else if(currentAmount === 1000000){
            props.setAmount(1500000);
            set_formated_amount(formatAmount(1500000));
        }else if(currentAmount === 1500000){
            props.setAmount(2000000);
            set_formated_amount(formatAmount(2000000));
        }else if(currentAmount === 2000000){
            props.setAmount(2500000);
            set_formated_amount(formatAmount(2500000));
        }else if(currentAmount === 2500000){
            props.setAmount(3000000);
            set_formated_amount(formatAmount(3000000));
        }else if(currentAmount === 3000000){
            props.setAmount(4000000);
            set_formated_amount(formatAmount(4000000));
        }else if(currentAmount === 4000000){
            props.setAmount(5000000);
            set_formated_amount(formatAmount(5000000));
        }else if(currentAmount === 5000000){
            props.setAmount(10000000);
            set_formated_amount(formatAmount(10000000));
        }
        
    }

    const minusAmount = () => {

        const currentAmount = props.amount;
        if(currentAmount === 10000000){
            props.setAmount(5000000);
        }else if(currentAmount === 5000000){
            props.setAmount(4000000);
        }else if(currentAmount === 4000000){
            props.setAmount(3000000);
        }else if(currentAmount === 3000000){
            props.setAmount(2500000);
        }else if(currentAmount === 2500000){
            props.setAmount(2000000);
        }else if(currentAmount === 2000000){
            props.setAmount(1500000);
        }else if(currentAmount === 1500000){
            props.setAmount(1000000);
        }else if(currentAmount === 1000000){
            props.setAmount(700000);
        }else if(currentAmount === 700000){
            props.setAmount(500000);
        }

    }

    useEffect(()=>{
        set_formated_amount( formatAmount( amount ) );  
    },[amount]);
     
    return (
        <div className={ props.className ? " plus-minus-component " + props.className : " plus-minus-component " }>
            <div className='row'>
                <div className="targetbar_outer">
                    <div className="targetbar_title">
                        <div className="font14 fw500 color182">Desired Cover Amount</div>
                        <div> 
                            <div className="tragetvalue font13 fw700 colorf47"> ₹ { inWords(amount) } </div>
                        </div>
                    </div> 
                   {/*  <span className="text-type-1">You can choose a number you are comfortable with. </span>
                    <span className="text-type-1">Howwever, we wouldn't recommend going bellow ₹ 80 L . </span>  */}
                </div>  
            </div>  
            <div className='col-md-12 mt20'>
                <div className="plus-minus-wpr">                           
                    <button type="button" onClick={minusAmount} className='font13 fw600'> <i className="fa-solid fa-minus mr5"></i> </button>
                    <span className='rupee-icon'>₹</span> <input type="text" className="font14 fw500 ml15 mr15" value={formated_amount}  readOnly={true} />
                    <button type="button" className="greenBtn font13 fw600" onClick={plusAmount}> <i className="fa-solid fa-plus mr5"></i>  </button> 
                </div> 
            </div>
        </div>
    );
}

export default PlusMinusInputHealth;